import React, { FC } from "react";
import { Outlet } from "react-router-dom";

/** 音色库嵌套路由壳：子页面渲染在 PremiumWorkspaceLayout 的 `home-series__scroll` 内 */
export const VoiceLibraryWorkspaceOutlet: FC = () => <Outlet />;
